import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { webApiHeaders } from "../../apiConfig";
import { ProfileContext } from "../../context/ContextProfile";

import ProfileShell from "./ProfileShell";
import Header from "../../components/profile/Header";
import Footer from "../../components/profile/Footer";
import Gallery from "../../components/profile/gallery/Gallery";
import Silbina from "../../components/profile/Silbina";

// The anonymous /v1/web/village-info endpoint only exists in the new
// (hardened) API. While production still runs the old API it answers 404, and
// every QR / aldealista.com/<village> link bounced to the home page. Until the
// new API is live, fall back on a 404 to the legacy app endpoint the old web
// used (same response shape). Remove the fallback once the new API is deployed.
const WEB_VILLAGE_INFO = "https://services.aldealista.com/v1/web/village-info";
const LEGACY_VILLAGE_INFO =
  "https://services.aldealista.com/v1/app/village-info";
const LEGACY_WEB_USER = {
  userEmail: "gabriel@vpfscandinavia.no",
  userUid: "9cT5kgJ7oyWaA1roSxBUgZgGA1S2",
};

function fetchVillage(code) {
  const params = { code, isScan: 1 };
  return axios({
    method: "post",
    url: WEB_VILLAGE_INFO,
    headers: webApiHeaders,
    params,
  }).catch((error) => {
    if (error.response?.status !== 404) throw error;
    return axios({
      method: "post",
      url: LEGACY_VILLAGE_INFO,
      params: { ...params, ...LEGACY_WEB_USER },
    });
  });
}

// Route: /:code  →  aldealista.com/<village> (the printed QR target).
// Resolves the code against the API and renders that village's profile.
export default function VillageProfile() {
  const { code } = useParams();
  const navigate = useNavigate();
  const { modifyVillage } = useContext(ProfileContext);

  const [isMegaMatch, setIsMegaMatch] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Legacy static page, kept on the marketing host.
    if (code === "mapadeseorural") {
      window.location.replace("https://aldealista.com/mapadeseorural.html");
      return;
    }

    let active = true;
    setReady(false);

    fetchVillage(code)
      .then((res) => {
        if (!active) return;
        const found = res.data.errorCode === 0;

        if (found) modifyVillage(res.data);

        // "silbina" always renders the megamatch variant, even without data.
        if (code === "silbina") {
          setIsMegaMatch(true);
          setReady(true);
        } else if (found) {
          setReady(true);
        } else {
          navigate("/", { replace: true });
        }
      })
      .catch(() => {
        if (active) navigate("/", { replace: true });
      });

    return () => {
      active = false;
    };
  }, [code]);

  if (!ready) return null;

  return (
    <ProfileShell>
      {isMegaMatch ? (
        <>
          <Silbina />
          <Footer />
        </>
      ) : (
        <>
          <Header />
          <Gallery />
          <Footer />
        </>
      )}
    </ProfileShell>
  );
}
